// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"f7db4526","377":"1d29e3ca","726":"b28817a1","870":"3a46799b","958":"96a6e234"}[chunkId] + ".chunk.js";
};